import React from 'react';
import PropTypes from 'prop-types';

class PaginatedTable extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'PaginatedTable';
        this.random = Date.now();
        this.state = {

        }
        this.$table;
    }
    componentDidMount() {
    	this.$table = $('#table-' + this.random);
    	this.$table.dataTable(this.state);
    }
    componentWillUpdate(prevProps, prevState) {
    	this.$table.DataTable().destroy();
    }
    componentDidUpdate(prevProps, prevState) {
     	this.$table.dataTable(this.state);     
    }
    render() {
        return (
        	<table id={'table-'+this.random} table-layout='fixed' className="table table-bordered table-striped md-none">
        		{this.props.children}
        	</table>
        );
    }
}

export default PaginatedTable;



// WEBPACK FOOTER //
// ./src/browser/components/ui/paginatedTable.js